
//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/popup'
import 'devextreme/ui/popover'

//#endregion

import { SaveColumnSettingsController } from './save-column-settings.controller'

//#region Asset Imports

import './save-column-settings.scss'
import * as TEMPLATE from './save-column-settings.tpl.html'

//#endregion

export class SaveColumnSettingsDirective implements ng.IDirective {
    constructor() { }

    scope = {
        gridName: '=',
        gridId: '=?'
    }
    controller = ['$scope', '$timeout', ($scope, $timeout) => new SaveColumnSettingsController($scope, $timeout)]
    restrict = 'E'
    template = TEMPLATE
}